import type { ChipOwnProps } from '@mui/material';
import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';
import { isNullOrUndefined } from '@weft/utils';

export const MuiChip: Components<Omit<Theme, 'components'>>['MuiChip'] = {
  styleOverrides: {
    outlined: ({ theme, ownerState }) => ({
      border: 'none',
      backgroundColor: theme.palette[getColor(ownerState.color)].selected,
      color: theme.palette[getColor(ownerState.color)].dark,
      '&:hover': {
        boxShadow: 'none',
      },
    }),
  },
};

function getColor(color?: ChipOwnProps['color']) {
  if (isNullOrUndefined(color) || color === 'default') {
    return 'primary';
  }

  return color;
}